export const CUSTOMER_IS_INTERESTED = 'customer-is-interested';
export const CUSTOMER_IS_INTERESTED_TOO  = 'customer-is-interested-too';
export const CUSTOMER_REQUESTED_VITA = 'customer-requested-vita';
export const APPLICANT_DECLINED_VITA = 'applicant-declined-vita';
export const APPLICANT_SENT_VITA = 'applicant-sent-vita';
export const APPLICANT_IS_INTERESTED = 'applicant-is-interested';
export const APPLICANT_IS_INTERESTED_TOO = 'applicant-is-interested-too';
export const CUSTOMER_SENT_APPOINTMENT_TO_APPLICANT = 'customer-sent-appointment-to-applicant';
export const APPLICANT_APPOINTMENT_DATE_COUNTER_PROPOSAL = 'applicant-appointment-date-counter-proposal';
export const APPLICANT_REQUESTED_NEW_APPOINTMENT_DATES = 'applicant-requested-new-appointment-dates';
export const APPLICANT_DEFERRED_APPOINTMENT = 'applicant-deferred-appointment';
export const CUSTOMER_DEFERRED_APPOINTMENT = 'customer-deferred-appointment';
export const SENT_OFF_BY_APPLICANT = 'sent-off-by-applicant';
export const SENT_OFF_BY_CUSTOMER = 'sent-off-by-customer';
export const APPOINTMENT_CONFIRMED = 'appointment-confirmed';
export const SEND_APPOINTMENT_ACCESS_LINK = 'send-appointment-access-link';
export const POST_APPOINTMENT = 'post-appointment';
export const ALTERNATIVE_APPOINTMENT_POSSIBLE_FOR_CUSTOMER = 'alternative-appointment-possible-for-customer';
export const APPLICANT_WANTS_ALTERNATIVE_APPOINTMENT = 'applicant-wants-alternative-appointment';
export const FOLLOW_UP_APPOINTMENT = 'follow-up-appointment';
export const COLLABORATION = 'collaboration';
export const APPLICANT_INTERESTED_IN_COLLABORATION = 'applicant-interested-in-collaboration';
export const APPLICANT_INTERESTED_IN_COLLABORATION_WANTS_TO_WAIT = 'applicant-interested-in-collaboration-wants-to-wait';
export const COLLABORATION_ACCEPT = 'collaboration-accept';
export const SENT_OFF_BY_SYSTEM = 'sent-off-by-system';